export default __webpack_public_path__ + "static/media/lining22.db81b4b2.jpeg";